module.exports = __webpack_public_path__ + "img/background_mobile.caca300.webp";